import { Injectable } from '@angular/core';
import { BehaviorSubject, lastValueFrom, Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { UserService } from './user.service';
import { User } from '../models/api.models';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;
import { DatePipe } from '@angular/common';
import { ThemeService } from './theme.service';
import { MatDialog } from '@angular/material/dialog';
import { OverlayContainer } from '@angular/cdk/overlay';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PosthogService } from './posthog.service';
@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly timezonePreferenceStorageKey = 'userTimezonePreferences';
  commonSer: any;
  url: any;
  redirectURL: any;
  private readonly cart: any = [];
  cartBS = new BehaviorSubject<any>(this.cart);
  castCartData = this.cartBS.asObservable();
  currentUser: any = undefined;
  currentUserBS = new BehaviorSubject(this.currentUser);
  setCurrentUser: BehaviorSubject<any>;
  castCurrentUser = this.currentUserBS.asObservable();
  taskServer = environment.eeTaskServer;
  dollarUS = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  rupeeIndian = Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
  });
  euroGerman = Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  });

  private readonly userSubject: BehaviorSubject<User>;
  public user: Observable<User>;
  private planSubject = new Subject<string>();
  plan$ = this.planSubject.asObservable();

  constructor(
    private readonly http: HttpClient,
    private readonly us: UserService,
    public datepipe: DatePipe,
    private readonly themeService: ThemeService,
    private readonly router: Router,
    public dialog: MatDialog,
    private readonly posthogService: PosthogService,
    private readonly snackBar: MatSnackBar,
    private readonly overlayContainer: OverlayContainer,
  ) {
    this.url = environment.usersServer;
    if (localStorage.getItem('key') !== null) {
      this.userSubject = new BehaviorSubject<User>(
        JSON.parse(localStorage.getItem('key') ?? ''),
      );
      this.user = this.userSubject.asObservable();
    } else {
      this.userSubject = new BehaviorSubject<any>(undefined);
      this.user = this.userSubject.asObservable();
    }
  }

  public get userValue(): User {
    return this.userSubject.getValue();
  }

  /**
   * @deprecated This method is deprecated, use method setAndGetCurrentUser moving forward
   */
  public getCurrentUser(): any {
    // //(environment.eeTaskServer);
    this.castCurrentUser = this.currentUserBS.asObservable();
    let retVal: any;
    let tokenStr: any = sessionStorage.getItem('jwttoken')!;
    if (tokenStr) {
      if (tokenStr.includes('Msg')) return tokenStr;
      const decodedToken: any = new JwtHelperService().decodeToken(tokenStr);
      // //(decodedToken);
      if (decodedToken) {
        this.currentUserBS.next(decodedToken);
        retVal = decodedToken;
        if (decodedToken?.id) {
          this.us.personalInfo(decodedToken?.id).subscribe((result: any) => {
              this.cacheCurrentUser(result);
          });
        }
      }
    }
    return retVal;
  }

  public async checkIfUserVerified(): Promise<boolean> {
    let tokenStr: any = sessionStorage.getItem('jwttoken')!;
    if (tokenStr) {
      if (tokenStr.includes('Msg')) return tokenStr;
      const decodedToken: any = new JwtHelperService().decodeToken(tokenStr);

      return decodedToken?.verified || false;
    }
    return false;
  }

  public async setAndGetCurrentUser(): Promise<any> {
    this.castCurrentUser = this.currentUserBS.asObservable();
    let tokenStr: any = sessionStorage.getItem('jwttoken')!;
    if (tokenStr) {
      if (tokenStr.includes('Msg')) return tokenStr;
      const decodedToken: any = new JwtHelperService().decodeToken(tokenStr);
      // console.log('decodedToken', decodedToken);
      if (decodedToken) {
        this.currentUserBS.next(decodedToken);
        if (decodedToken?.id) {
          const result = await lastValueFrom(
            this.us.personalInfo(decodedToken?.id),
          );
          return this.cacheCurrentUser(result);
        }
      }
    }
    return null;
  }

  saveUserTimezonePreference(email: string, timezone: string): void {
    if (!email || !timezone) {
      return;
    }

    const preferences = this.getTimezonePreferences();
    preferences[email.toLowerCase()] = timezone;
    localStorage.setItem(
      this.timezonePreferenceStorageKey,
      JSON.stringify(preferences),
    );

    if (this.userValue?.email?.toLowerCase() === email.toLowerCase()) {
      this.cacheCurrentUser({ ...this.userValue, timezone });
    }
  }

  getUserTimezonePreference(email: string): string | null {
    if (!email) {
      return null;
    }

    const preferences = this.getTimezonePreferences();
    return preferences[email.toLowerCase()] || null;
  }

  private cacheCurrentUser(user: any): any {
    if (!user) {
      return user;
    }

    const timezone = user?.timezone || this.getUserTimezonePreference(user?.email);
    const cachedUser = timezone ? { ...user, timezone } : user;

    this.userSubject.next(cachedUser);
    this.user = this.userSubject.asObservable();
    localStorage.setItem('key', JSON.stringify(cachedUser));
    return cachedUser;
  }

  private getTimezonePreferences(): Record<string, string> {
    const rawPreferences = localStorage.getItem(this.timezonePreferenceStorageKey);

    if (!rawPreferences) {
      return {};
    }

    try {
      return JSON.parse(rawPreferences);
    } catch {
      return {};
    }
  }

  public loginwithEmail(loginparams: string): any {
    this.us.getUserWithEmailnPswrd(loginparams).subscribe(
      (result: any) => {
        this.saveToken(result);
        return true;
      },
      (err) => {
        return false;
      },
    );
  }
  saveToken(token: any) {
    // //(token)
    if (token.Msg === 'User not registered' || token.Msg === 'Wrong password') {
      this.currentUser = undefined;
      this.currentUserBS.next(this.currentUser);
      this.getCurrentUser();
      // //('hello')
      sessionStorage.setItem('jwttoken', JSON.stringify(token));
    } else {
      sessionStorage.setItem('jwttoken', JSON.stringify(token.jwt));
    }
  }
  logout() {
    // Close all dialogs and snackbars
    this.dialog.closeAll();
    this.snackBar.dismiss();
    const loginTimeStr = localStorage.getItem('loginTime');
    const logoutTime = new Date();
    const username = localStorage.getItem('loggedUser') || 'Unknown';
    let sessionDuration = 'Unknown';
    if (loginTimeStr) {
      const loginTime = new Date(loginTimeStr);
      const durationMs = logoutTime.getTime() - loginTime.getTime();
      const seconds = Math.floor((durationMs / 1000) % 60);
      const minutes = Math.floor((durationMs / (1000 * 60)) % 60);
      const hours = Math.floor(durationMs / (1000 * 60 * 60));

      sessionDuration = `${hours}h ${minutes}m ${seconds}s`;
    }
    if (sessionDuration !== 'Unknown') {
      this.posthogService.identify(username, {
        email: username,
        firstLogin: username,
      });

      this.posthogService.capture('Logout', {
        method: 'standard',
        message: `${username} successfully logged out after ${sessionDuration}`,
        email: username,
      });
    }

    // Optional: Remove any stray overlays (sometimes helpful)
    this.overlayContainer.getContainerElement().innerHTML = '';

    sessionStorage.removeItem('jwttoken');
    localStorage.removeItem('key');
    this.currentUserBS.next(this.currentUser);
    localStorage.removeItem('darkMode');
    localStorage.removeItem('loginTime');
    localStorage.removeItem('loggedUser');
    this.themeService.setDarkMode(false);
    this.currentUserBS.next(this.currentUser);
  }

  logoutAndReset(): void {
    this.logout();
    this.dialog.closeAll();
    this.router.navigate(['login']);
  }

  addMoneyToWallet(
    amount: any,
    user: any,
    method: any,
    top_up: any,
    subscription: any,
    topUp: any,
  ) {
    //(user)
    const key = 'EarthEye';
    let url = `${this.taskServer}/order/addmoney/${key}`;

    const orderBody = {
      user: { name: user.name, email: user.email, userId: user.id },
      amount: amount,
      paymentMethod: method,
      top_up_amount: top_up,
      subscription_amount: subscription,
      topUp: topUp,
    };
    //(orderBody)

    const res = this.http.post(`${url}`, { orderBody });
    return res;
  }

  addQuotationToTopup(quotationAmount: any, userId: any) {
    return this.http.post(`${environment.eeTaskServer}/quotes/addTopUpQuotes`, {
      quotationAmount: quotationAmount,
      userId: userId,
    });
  }

  delCartdata(cartid: any, userId: any, sensorId: any) {
    let cartdetail = { taskid: cartid, item: -9, userId, sensorId };
    if (cartid.includes('#')) {
      const taskid = cartid.split('#')[0];
      const item = parseInt(cartid.split('#')[1]);
      cartdetail = { taskid, item, userId, sensorId };
    }
    const res = this.http.post(`${this.taskServer}/cart/delete`, {
      cartdetail,
    });
    return res;
  }

  emitPlan(plan: any) {
    this.planSubject.next(plan);
  }
  setCookie(name: string, value: string, minutes: number) {
    const expires = new Date(Date.now() + minutes * 60 * 1000).toUTCString();
    let cookieStr = `${name}=${encodeURIComponent(
      value,
    )}; expires=${expires}; path=/`;

    if (window.location.hostname !== 'localhost') {
      cookieStr += `; Secure; SameSite=None; domain=.eartheye.space`;
    }

    document.cookie = cookieStr;
  }

  getCookie(name: string): string | null {
    const match = document.cookie.match(
      new RegExp(
        '(?:^|; )' +
          name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') +
          '=([^;]*)',
      ),
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  deleteCookie(name: string) {
    const past = 'Thu, 01 Jan 1970 00:00:00 UTC';
    let cookieStr = `${name}=; expires=${past}; path=/`;

    if (window.location.hostname !== 'localhost') {
      cookieStr += `; Secure; SameSite=None; domain=.eartheye.space`;
    }

    document.cookie = cookieStr;
  }

  restoreSessionFromLocalStorage(): void {
    const data = localStorage.getItem('sessionStorageCopy');

    if (data) {
      const sessionData = JSON.parse(data);

      Object.keys(sessionData).forEach(key => {
        sessionStorage.setItem(key, sessionData[key]);
      });

      localStorage.removeItem('sessionStorageCopy');
    }
  }
}
